<ng-container *transloco="let t">
    <div class="mobile-unsupported">
        <div class="mobile-unsupported__card">
            <img class="mobile-unsupported__logo" [src]="brandLogoUrl" [alt]="t('app.title')" />

            <div class="mobile-unsupported__icon" aria-hidden="true">
                <span class="mobile-unsupported__device mobile-unsupported__device--tablet">
                    <i class="bi bi-tablet"></i>
                </span>
                <span class="mobile-unsupported__device mobile-unsupported__device--desktop">
                    <i class="bi bi-laptop"></i>
                </span>
            </div>

            <h1 id="mobile-unsupported-title" class="mobile-unsupported__title">
                {{ t('app.mobileUnsupported.title') }}
            </h1>

            <p id="mobile-unsupported-message" class="mobile-unsupported__message">
                {{ t('app.mobileUnsupported.message') }}
            </p>
        </div>
    </div>
</ng-container>
